import React from 'react';
import money from '../../img/for_table/money.svg';
import './style.scss';
import { setOpenModal1 } from '../../store/actions';
import { useDispatch } from 'react-redux';

const SliderItem = ({ data, slideIndex, totalSlides, width, currentSlide, slide }) => {
	const dispatch = useDispatch();

	const handleClick = () => {
		if ( width < 600 && slideIndex !== currentSlide ) {
			if ( currentSlide === totalSlides - 1 && slideIndex === 0){
				slide.slickNext();
			} else if(currentSlide === 0 && slideIndex === totalSlides - 1){
				slide.slickPrev()
			} else if(currentSlide < slideIndex){
				slide.slickNext();
			} else {
				slide.slickPrev()
			}
		}
	};

	return (

		<div className="slider_item" style={ width > 600 ? { margin: '15px auto' } : {} } onClick={ handleClick }>

			<div className='img_container'
			     onMouseUp={ () => {} }
			     onMouseDown={ () => {} }
			     onClick={ () => dispatch( setOpenModal1( data ) ) }
			     style={ { background: !!data.image && `url(${ data.image })` } }>
				<div className='header_controllers'>
					<span className='counter'>{ slideIndex + 1 }/{ totalSlides }</span>
					<span className='modal-trigger'>
                    <span onClick={ () => dispatch( setOpenModal1( data ) ) }>•••</span>
                </span>
				</div>
				<div className='slider_item_text'>
					<div className='shadow_slider'/>
					<p>
						{ data.text.toUpperCase() }
					</p>
				</div>
			</div>
			<div className="slider_item_price_container">
				{ data.price ? (
					<span className="slider_item_price">
            <img src={ money } alt=""/>
            <p>{ data.price }</p>
          </span>
				) : (
					<span className="slider_item_place">
            <p>{ data.places } место</p>
          </span>
				) }
			</div>
		</div>
	);
};

export default SliderItem;
